import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { isArray } from 'lodash';
import { ArticleContent } from '../../../../__generated__/graphql';
import { ExtraAction } from '../../api';
import { addArticle, findArticleFromCategory } from '../../articles';

export interface SystemState {
  appName: string;
  mainAddress: string;
  addresses: string[];
  logo: string;
  institutional: string;
  facebook: string;
  instagram: string;
  twitter: string;
  linkedin: string;
  privacyPolicy: string;
}

const INITIAL_STATE: SystemState = {
  appName: '',
  mainAddress: '',
  addresses: [],
  logo: '',
  institutional: '',
  facebook: '',
  instagram: '',
  twitter: '',
  linkedin: '',
  privacyPolicy: '',
};

const systemSlice = createSlice({
  name: 'configurations',
  initialState: INITIAL_STATE,
  reducers: {
    configure: (state, action: PayloadAction<Array<ArticleContent>>) => {
      if (!isArray(action?.payload)) {
        return state;
      }
      const mapOfValues = new Map();
      action.payload.forEach((item) => {
        const { type, value } = item;
        if (mapOfValues.get(type)) {
          const existentItem = mapOfValues.get(type);
          if (type === 'address') {
            mapOfValues.set(
              type,
              isArray(existentItem) ? [...existentItem, value] : [existentItem, value],
            );
          } else {
            mapOfValues.set(type, [value]);
          }
        } else {
          mapOfValues.set(type, value);
        }
      });

      const addresses = mapOfValues.get('address') || [];
      const mainAddress = isArray(addresses) ? addresses[0] : addresses.length ? addresses : '';
      const logo = mapOfValues.get('logo');
      const appName = mapOfValues.get('title');
      const institutional = mapOfValues.get('content');
      const facebook = mapOfValues.get('facebook');
      const instagram = mapOfValues.get('instagram');
      const twitter = mapOfValues.get('twitter');
      const linkedin = mapOfValues.get('linkedin');
      const privacyPolicy = mapOfValues.get('privacyPolicy');
      return {
        ...state,
        addresses,
        appName: appName,
        mainAddress: mainAddress ?? '',
        institutional: institutional ?? '',
        facebook,
        instagram,
        twitter,
        linkedin,
        privacyPolicy,
        logo: logo && logo.length ? logo : '',
      };
    },
  },
});

export const { configure } = systemSlice.actions;

export const loadSiteName = () => {
  const callback = (onSuccess: string): boolean => onSuccess === addArticle.type;
  const customErrorsMap = new Map<number, string>([
    [404, 'A configuração do site deve ser executada, Verifique!'],
  ]);
  const extraActions: ExtraAction = {
    condition: callback,
    preProccess: (payload) => {
      return { ...payload };
    },
    actionName: configure.type,
  };
  console.log(extraActions);

  return findArticleFromCategory('configurations', [extraActions], customErrorsMap);
};

export default systemSlice.reducer;
